import { useCallback, useState } from "react";
import { apiFetch } from "../lib/api";
import type { Customer } from "../pages/Customers/customers.types";

export function useCustomers() {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiFetch("/customers");
      if (!response.ok) throw new Error("Erreur lors du chargement des clients.");
      const data = await response.json();
      setCustomers(Array.isArray(data) ? data : []);
    } finally {
      setLoading(false);
    }
  }, []);

  return { customers, loading, fetchCustomers };
}
